import React, { ReactElement, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useSuccessMessageContext } from '../../../../context/SuccessMessageContext';
import { useClient, useClientStatusContext } from '../../../../context/ClientStatusContext';
import routes from '../../../../routing/routes';
import useFieldErrorMessages from '../../../useFieldErrorMessages';
import PouzitiePredpis from '../../../../model/PouzitiePredpis';
import {
  updateTerminPouzitieVPredpisoch,
} from '../../../../client/termin/terminPouzitieVPredpisochUpdateClient';
import PouzitieVPredpisochUpdateForm from './component/PouzitieVPredpisochUpdateForm';
import { technickePricinyErrorStatus } from '../../../../constants/ErrorConstant';

interface Props {
  initialPouzitiePredpisList: Array<PouzitiePredpis>;
}

const PouzitieVPredpisochUpdate = ({ initialPouzitiePredpisList }: Props): ReactElement => {
  const [pouzitiePredpisList, setPouzitiePredpisList] = useState(initialPouzitiePredpisList);
  const { tezaurusUuid, terminUuid } = useParams<{ tezaurusUuid: string, terminUuid: string }>();

  const {
    wrapClient: updateTerminPouzitieVPredpisochClient,
    status: updateStatus,
  } = useClient(updateTerminPouzitieVPredpisoch);

  const navigate = useNavigate();
  const { displaySuccess } = useSuccessMessageContext();
  const { handleStatus } = useClientStatusContext();
  const {
    getFieldErrorMessage,
    clearAllFieldErrorMessages,
  } = useFieldErrorMessages();

  const handleSubmit = async (event): Promise<void> => {
    event.preventDefault();
    await updateTerminPouzitieVPredpisochClient(terminUuid, pouzitiePredpisList);
    navigate(routes.tezaurus.admin.termin.detail.withParams(tezaurusUuid, terminUuid));
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  useEffect(() => {
    if (updateStatus?.responseCode === 404) {
      handleStatus(technickePricinyErrorStatus);
    }
  }, [updateStatus, handleStatus]);

  return (
    <PouzitieVPredpisochUpdateForm
      pouzitiePredpisList={pouzitiePredpisList}
      setPouzitiePredpisList={setPouzitiePredpisList}
      onSubmit={handleSubmit}
      clearAllFieldErrorMessages={clearAllFieldErrorMessages}
      getFieldErrorMessage={getFieldErrorMessage}
      loading={updateStatus.loading}
    />
  );
};

export default PouzitieVPredpisochUpdate;
